import React, { memo } from 'react';

const Badge = memo(({ 
  children,
  variant = 'default',
  size = 'medium',
  className = '',
  style = {},
  ...props 
}) => {
  const baseStyles = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '6px',
    fontWeight: '500',
    ...style
  };

  const variants = {
    default: {
      backgroundColor: '#f3f4f6',
      color: '#374151'
    },
    primary: {
      backgroundColor: '#dbeafe',
      color: '#1e40af'
    },
    success: {
      backgroundColor: '#d1fae5',
      color: '#065f46'
    },
    warning: {
      backgroundColor: '#fef3c7',
      color: '#92400e'
    },
    danger: {
      backgroundColor: '#fee2e2',
      color: '#991b1b'
    },
    info: {
      backgroundColor: '#e0f2fe',
      color: '#0c4a6e'
    }
  };

  const sizes = {
    small: {
      padding: '2px 6px',
      fontSize: '10px',
      minHeight: '16px'
    },
    medium: {
      padding: '4px 8px',
      fontSize: '12px',
      minHeight: '20px'
    },
    large: {
      padding: '6px 12px',
      fontSize: '14px',
      minHeight: '24px'
    }
  };

  const badgeStyles = {
    ...baseStyles,
    ...variants[variant],
    ...sizes[size]
  };

  return (
    <span className={`badge ${className}`} style={badgeStyles} {...props}>
      {children}
    </span>
  );
});

export default Badge;

Badge.displayName = 'Badge';
